;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputTagsController', InputTagsController)

  /* @ngInject */
  function InputTagsController ($scope, $attrs, $timeout, $translate, UdsModalService) {
    const getUpgradeCompanyPlanDialogController = () => import('../../dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

    const api = {
      _emitChanges,
      _onRemove,
      _onAdd,
      _openUpgradeCompanyPlanDialog,
      getUpgradeCompanyPlanDialogController
    }
    this.getApi = () => api

    activate()

    function activate () {
      // duplicate values from value to model
      if ($scope.value && $scope.value.length > 0) {
        $scope.model = [...$scope.value]
      } else if (!$scope.model) {
        $scope.model = []
      }

      $timeout(() => {
        $attrs.$$element.find('.input-tags-dropdown').dropdown({
          allowAdditions: true,
          onAdd: api._onAdd,
          onRemove: api._onRemove,
          fullTextSearch: true,
          hideAdditions: false,
          message: {
            addResult: $translate.instant('add') + ' <b>{term}</b>'
          }
        })
        $attrs.$$element.find('.input-tags-dropdown').dropdown('set selected', $scope.value)
      }, 1000, false)
    }

    function _onAdd (value, text) {
      if (!$scope.model) {
        $scope.model = []
      }

      if ($scope.model.includes(text)) {
        return
      }

      $scope.model.push(text)
      api._emitChanges($scope.model)
    }

    function _onRemove (value) {
      if (!$scope.model) {
        return
      }
      const index = $scope.model.indexOf(value)
      if (index > -1) {
        $scope.model.splice(index, 1)
        api._emitChanges($scope.model)
      }
    }

    function _emitChanges (value) {
      if ($scope.change) {
        $scope.change({
          $event: {
            modelPropertyName: $scope.modelPropertyName,
            modelNewValue: value
          }
        })
      }
    }

    function _openUpgradeCompanyPlanDialog (pricingData) {
      api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
        const upgradeCompanyPlanDialog = UdsModalService.createModal({
          controller: UpgradeCompanyPlanDialogController,
          modalName: 'upgradeCompanyPlanDialog',
          data: pricingData
        })
        upgradeCompanyPlanDialog.open()
      })
    }

    $scope.handleInputClick = () => {
      if ($scope.pricing) {
        api._openUpgradeCompanyPlanDialog($scope.pricingData)
      }
    }
  }
})()
